import { Mapper } from '@data/base/mapper';
import { VehicleEntity } from '@domain/dto/vehicle/vehicle-get.dto';
export class VehicleMapper extends Mapper<VehicleEntity> {
    fromJson(param: any): VehicleEntity {
        return param;
    }
}
